import type { GetUserPropertyDetailsFloorPlanWebDto } from '@zg-rentals/ts-rental-manager-api-beta-client';

const FLOOR_PLAN = 'floorPlan';
const UNIT = 'unit';
const AMENITY = 'amenity';
const SINGLE_FAMILY = 'singleFamily';
const TOUR_TYPE = {
  [FLOOR_PLAN]: 'FloorPlan',
  [UNIT]: 'Unit',
  [AMENITY]: 'Amenity',
  [SINGLE_FAMILY]: 'SingleFamily',
} as const;
export type KeysOfTourType = keyof typeof TOUR_TYPE;

const getDefaultTourLabel = (
  tourType: KeysOfTourType,
  floorPlanIndex: null | number = null,
  unitIndex: null | number = null,
  {
    vrModels = [],
    externalTours = [],
    floorplans = [],
    units = [],
  }: Partial<{
    vrModels: Array<unknown>;
    externalTours: Array<unknown>;
    floorplans: Array<Pick<GetUserPropertyDetailsFloorPlanWebDto, 'name' | 'units'>>;
    units: Array<{ name: string }>;
  }> = {},
) => {
  if (tourType === SINGLE_FAMILY) {
    return 'Tour';
  }

  if (tourType === AMENITY) {
    const tourCount = vrModels.length + externalTours.length;
    return `Tour ${tourCount + 1}`;
  }

  let prefix: string | undefined = '';
  const floorPlan = floorplans[floorPlanIndex as number];
  // Unit tour without floor plan
  if (floorPlanIndex === null && unitIndex !== null) {
    prefix = units[unitIndex]?.name;
    // Unit tour with floor plan
  } else if (floorPlanIndex !== null && unitIndex !== null) {
    const unit = floorPlan?.units?.[unitIndex];
    prefix = unit?.name;
  } else {
    prefix = floorPlan?.name;
  }
  return `${prefix || 'New'} tour`;
};

export { getDefaultTourLabel };
